import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductListDTO extends TeamAccessDTO {

    id: string;

    itemNumber: string;

    name: string;

    description: string;

}
